<template>
    <li class="hidden top-0 left-0 opacity-0 pointer-event-none" :class="[mjSlider.active ? 'selected' : '']">
        <img alt="Fly Bag" class="wide shadow w-full" :src="mjSlider.img">
    </li>
</template>

<script>
    export default {
        name: "SliderOneContent",
        props: {
            mjSlider: {
                type: Object
            }
        }
    }
</script>

<style scoped>

</style>